import { render, staticRenderFns } from "./PaySectionsManage.vue?vue&type=template&id=2fe4e0a0&"
import script from "./PaySectionsManage.vue?vue&type=script&lang=js&"
export * from "./PaySectionsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports